import { api } from "@/app/api";

const KEY = "od_referral";

export function getStoredReferral() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

/** Capture a ?ref=CODE referral click. Stores {code, visitor_token} so attribution
 * survives registration, login and return visits. */
export async function captureReferralFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("ref");
  if (!code) return;
  const existing = getStoredReferral();
  if (existing?.code === code.toUpperCase()) return;
  try {
    const { data } = await api.post("/referrals/capture", { code, landing_path: window.location.pathname });
    if (data.valid) {
      localStorage.setItem(KEY, JSON.stringify({ code: data.code, visitor_token: data.visitor_token, captured_at: new Date().toISOString() }));
    }
  } catch {
    /* referral capture must never break the public site */
  }
}

/** Link the stored referral to the now-authenticated learner (register or login). */
export async function attributeStoredReferral() {
  const stored = getStoredReferral();
  if (!stored?.visitor_token) return;
  try {
    const { data } = await api.post("/referrals/attribute", { code: stored.code, visitor_token: stored.visitor_token });
    if (data.attributed) localStorage.removeItem(KEY);
  } catch {
    /* keep the referral stored for a later attempt */
  }
}

/** Mark that a referred visitor started the journey (once per session). */
export async function markJourneyStarted() {
  const stored = getStoredReferral();
  if (!stored?.visitor_token || sessionStorage.getItem("od_referral_journey")) return;
  sessionStorage.setItem("od_referral_journey", "1");
  try {
    await api.post("/referrals/journey-start", { visitor_token: stored.visitor_token });
  } catch {
    /* non-critical */
  }
}
